import callApi, { callSelfAPI } from '../../util/apiCaller';
import { buildLeadFormResponse } from '../../util/leadFormLocalResolver';

import {loadEvent} from './EventActions';
import moment from 'moment';
import {saveEventIdToStorage} from '../../util/vmStorageHandler';
import {gtmAlert} from '../../util/gtmTrigger';
import eventCallApi from '../../util/apiEventCaller';
import {sendFirstVerificationEmail, sendFirstVerificationSms} from './EventVerificationActions';
import gurgaonSubArea from "../../constants/leadform/gurgaon_sub_areas.json";
import delhiSubArea from "../../constants/leadform/delhi_sub_areas.json";
import goaSubArea from "../../constants/leadform/goa_sub_areas.json";
import faridabadSubArea from "../../constants/leadform/faridabad_sub_areas.json";
import ghaziabadSubArea from "../../constants/leadform/ghaziabad_sub_areas.json";
import noidaSubArea from "../../constants/leadform/noida_sub_areas.json";
import {generateMessageId} from "../../util/utility";

//SliderForm Filters
export const LOAD_FORM_FILTERS = 'LOAD_FORM_FILTERS';
export const LOAD_PRE_LOADED_LEAD_FORM_DATA = 'LOAD_PRE_LOADED_LEAD_FORM_DATA';
export const LOAD_POST_LEAD_FORM_VERIFIED_DATA = 'LOAD_POST_LEAD_FORM_VERIFIED_DATA';
export const LOAD_FORM_SUBAREAS = 'LOAD_FORM_SUBAREAS';
export const LOAD_LEAD_FORM_DATA = 'LOAD_LEAD_FORM_DATA';
export const FETCHING_LEAD_FORM_DATA = 'FETCHING_LEAD_FORM_DATA';
export const TOGGLE_LEAD_FORM_STATE = 'TOGGLE_LEAD_FORM_STATE';
export const TOGGLE_VENUE_LEAD_FORM_STATE = 'TOGGLE_VENUE_LEAD_FORM_STATE';
export const SUBMITTING_LEAD_FORM = 'SUBMITTING_LEAD_FORM';
export const SUBMIT_LEAD_FORM = 'SUBMIT_LEAD_FORM';
export const SET_VM_EVENT_REDIRECT_URL = 'SET_VM_EVENT_REDIRECT_URL';
export const LOAD_ACTIVE_TRIGGER_SLIDE = 'LOAD_ACTIVE_TRIGGER_SLIDE';
export const LOAD_VENUE_SLIDE_DATA = 'LOAD_VENUE_SLIDE_DATA';
export const SET_LEAD_FORM_VISIBLE_COUNT = 'SET_LEAD_FORM_VISIBLE_COUNT';
export const LOAD_SELECTED_LEAD_FORM = 'LOAD_SELECTED_LEAD_FORM';
export const LOAD_PRE_SELECT_FORM_AND_OPEN_LEADFORM = 'LOAD_PRE_SELECT_FORM_AND_OPEN_LEADFORM';
export const UPDATE_LEAD_FORM_VISIBLE_COUNT = 'UPDATE_LEAD_FORM_VISIBLE_COUNT';
export const TOGGLE_PRE_LEADFORM_BUTTON_STATUS = 'TOGGLE_PRE_LEADFORM_BUTTON_STATUS';
export const LOAD_FORM_PARAMS = 'LOAD_FORM_PARAMS';
export const GET_CURRENT_SELECTED_CITY = 'GET_CURRENT_SELECTED_CITY'
export const LOAD_PRE_SELECT_FORM_AND_OPEN_HOME_LEADFORM = 'LOAD_PRE_SELECT_FORM_AND_OPEN_HOME_LEADFORM';
export const TOGGLE_HOME_LEAD_FORM_STATE = 'TOGGLE_HOME_LEAD_FORM_STATE'
export const TOGGLE_VENUE_HOME_LEAD_FORM_STATE = 'TOGGLE_VENUE_HOME_LEAD_FORM_STATE'

export function togglePreLeadFormButtonState(status) {
    return {
        type: TOGGLE_PRE_LEADFORM_BUTTON_STATUS,
        isPreLeadFormButtonVisible: status,
    };
}

export function getCurrentSelectedCityPage(city) {
    return {
        type: GET_CURRENT_SELECTED_CITY,
        iscurrentcity: city,
    };
}

export function showFormBaseFiltersLoadingState(val) {
    return {
        type: FETCHING_FORM_BASE_FILTERS,
        isBaseFiltersLoading: !!val,
    };
}

export function loadPreLoadedLeadFormData(val) {
    return {
        type: LOAD_PRE_LOADED_LEAD_FORM_DATA,
        preLoadedLeadFormData: val,
    };
}

export function loadPostVerificationLeadForm(val) {
    return {
        type: LOAD_POST_LEAD_FORM_VERIFIED_DATA,
        postVerificationFormData: val,
    };
}

export function loadFormFilters(filters) {
    return {
        type: LOAD_FORM_FILTERS,
        isBaseFiltersLoaded: true,
        isBaseFiltersLoading: false,
        occasionFilters: filters.occasions,
        venuetypeFilters: filters.venuetypes,
    };
}

export function fetchFormBaseFilters() {
    return (dispatch) => {
        dispatch(showFormBaseFiltersLoadingState(true));
        return callApi('lead-form/base-filters', 'GET')
            .then(res => {
                if (res.status === 'Success') {
                    let result = {};
                    if (res && res.data.filters) {
                        res.data.filters.forEach(item => {
                            result[item.name] = item.params;
                        });
                    }
                    dispatch(loadFormFilters(result));
                }
            });
    };
}

export function showFormLocationFiltersLoadingState(val) {
    return {
        type: FETCHING_FORM_LOCATION_FILTERS,
        isLocationFiltersLoading: !!val,
    };
}

export function loadFormSubareas(subareas) {
    return {
        type: LOAD_FORM_SUBAREAS,
        isLocationFiltersLoaded: true,
        isLocationFiltersLoading: false,
        locationFilters: subareas.localities,
    };
}

export function loadPreSelectedLeadformAndOpenLeadForm(selectedLeadForm, leadFormState, leadFormCode, leadFormTriggerCode,leadFormType) {
    return {
        type: LOAD_PRE_SELECT_FORM_AND_OPEN_LEADFORM,
        selectedLeadForm,
        isLeadFormVisible: leadFormState,
        leadFormCode: leadFormCode ? leadFormCode : '',
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: {},
        leadFormType:leadFormType
    };
}

export function loadPreSelectedHomeLeadformAndOpenLeadForm(selectedLeadForm, leadFormState, leadFormCode, leadFormTriggerCode,leadFormType) {
    return {
        type: LOAD_PRE_SELECT_FORM_AND_OPEN_HOME_LEADFORM,
        selectedLeadForm,
        isHomeLeadFormVisible: leadFormState,
        leadFormCode: leadFormCode ? leadFormCode : '',
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: {},
        leadFormType:leadFormType
    };
}

export function handleLoadSelectedLeadForm(selectedLeadForm) {
    return {
        type: LOAD_SELECTED_LEAD_FORM,
        selectedLeadForm,
    };
}

export function fetchFormSubAreasByCity(city) {
    return (dispatch) => {
        dispatch(showFormLocationFiltersLoadingState(true));
        return callApi(`lead-form/${city}/subareas`, 'GET')
            .then(res => {
                if (res.status === 'Success') {
                    let result = {};
                    if (res && res.data.filters) {
                        res.data.filters.forEach(item => {
                            result[item.name] = item.params;
                        });
                    }
                    dispatch(loadFormSubareas(result));
                }
            });
    };
}

export function showLeadFormLoader(val) {
    return {
        type: FETCHING_LEAD_FORM_DATA,
        isFetchingLeadForm: val,
    };
}

export function loadLeadFormData(leadFormdata) {
    return {
        type: LOAD_LEAD_FORM_DATA,
        isFetchingLeadForm: false,
        leadFormData: leadFormdata,
    };
}

export function fetchPreLoadedLeadFormData(code) {
    return (dispatch) => {
        dispatch(showLeadFormLoader(true));
        return callApi(`lead-form/${code}`, 'GET')
            .then(res => {
                if (res.status === 'Success') {
                    dispatch(loadPreLoadedLeadFormData(res.data.leadform));
                } else {
                    dispatch(showLeadFormLoader(false));
                }
            });
    };
}

export function fetchLeadFormData(code) {
    return (dispatch) => {
        dispatch(showLeadFormLoader(true));
        return callApi(`lead-form/${code}`, 'GET')
            .then(res => {
                if (res.status === 'Success') {
                    dispatch(loadLeadFormData(res.data.leadform));
                } else {
                    dispatch(showLeadFormLoader(false));
                }
            });
    };
}

export function toggleLeadFormState(leadFormState, leadFormCode, leadFormTriggerCode) {
    return {
        type: TOGGLE_LEAD_FORM_STATE,
        isLeadFormVisible: leadFormState,
        leadFormCode: leadFormCode ? leadFormCode : '',
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: {},
    };
}

export function toggleHomeLeadFormState(leadFormState, leadFormCode, leadFormTriggerCode) {
    return {
        type: TOGGLE_HOME_LEAD_FORM_STATE,
        isHomeLeadFormVisible: leadFormState,
        leadFormCode: leadFormCode ? leadFormCode : '',
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: {},
    };
}

export function toggleVenueLeadFormState(leadFormState, selectedVenue, leadFormTriggerCode) {
    return {
        type: TOGGLE_VENUE_LEAD_FORM_STATE,
        isLeadFormVisible: leadFormState,
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: selectedVenue,
    };
}

export function toggleVenueHomeLeadFormState(leadFormState, selectedVenue, leadFormTriggerCode) {
    return {
        type: TOGGLE_VENUE_HOME_LEAD_FORM_STATE,
        isHomeLeadFormVisible: leadFormState,
        leadFormTriggerCode: leadFormTriggerCode ? leadFormTriggerCode : '',
        selectedVenue: selectedVenue,
    };
}

export function toggleLoaderForEventPlan(val) {
    return {
        type: SUBMITTING_LEAD_FORM,
        isPlanningEvent: !!val,
    };
}

export function setEventRedirectionUrl(url) {
    return {
        type: SET_VM_EVENT_REDIRECT_URL,
        eventSearchUrl: url,
    };
}

export function setInitialLeadFormVisibleCount(count) {
    return {
        type: SET_LEAD_FORM_VISIBLE_COUNT,
        leadformVisibleCount: parseInt(count),
    };
}

export function updateLeadFormVisibleCount() {
    return {
        type: UPDATE_LEAD_FORM_VISIBLE_COUNT,
    };
}

export function submitEventForRegistration(event) {
    return (dispatch) => {
        dispatch(toggleLoaderForEventPlan(true));
        dispatch(loadEvent({}));
        return eventCallApi(`v2/events/plan`, 'post', event)
            .then(resp => {
                dispatch(toggleLoaderForEventPlan(false));

                if (resp.status === 'Success') {
                    if (resp && resp.data && resp.data.eventid && resp.data.eventid !== '') {
                        // setEventCookie(new Date(moment(resp.data.event.event_date)
                        //   .add(1, 'days')
                        //   .toISOString()), resp.data.eventid);
                        saveEventIdToStorage(new Date(moment(resp.data.event.event_date)
                            .add(1, 'days')
                            .toISOString()), resp.data.eventid);
                        const created = resp.data.event;
                        dispatch(loadEvent(created));
                        // Same as LeadFormActions.planEvent / Next flow: send OTP right after plan,
                        // instead of relying only on SliderForm componentDidUpdate (which can miss).
                        const eventId = created && created._id ? created._id : resp.data.eventid;
                        if (
                            created &&
                            eventId &&
                            !created.isVerified &&
                            !created.isOTPSent
                        ) {
                            if (created.city === 'dubai') {
                                dispatch(
                                    sendFirstVerificationEmail(
                                        eventId,
                                        created.contact_email
                                    )
                                );
                            } else {
                                dispatch(
                                    sendFirstVerificationSms(
                                        eventId,
                                        created.contact_phone
                                    )
                                );
                            }
                        }
                        if (resp && resp.data && resp.data.event && resp.data.event.guests) {
                            if (parseInt(resp.data.event.guests) > 200) {
                                gtmAlert("lead_guest_count_gt_200")
                            }
                            if (parseInt(resp.data.event.guests) > 50) {
                                gtmAlert("lead_guest_count_gt_50")
                            }
                        }
                        // dispatch(setEventRedirectionUrl(resp.data.url));
                        // dispatch(toggleLeadFormState(false, '', ''));
                    } else {
                        // dispatch(userNotify('Server did not respond, please try again', 'error'));
                    }
                } else if (resp.status === 'Error' && resp.data.message) {
                    // dispatch(userNotify(resp.data.message, 'error'));
                } else {
                    // dispatch(userNotify('Server did not respond, please try again', 'error'));
                }
            })
            .catch(() => {
                dispatch(toggleLoaderForEventPlan(false));
            });
    };
}

export function loadLeadParams(cities, occasions) {
    return {
        type: LOAD_FORM_PARAMS,
        cities: cities,
        occasions: occasions,
    };
}

export function fetchLeadFormDataV2(city, { slideCode, category }) {
    return (dispatch) => {
        return Promise.resolve(buildLeadFormResponse(city, slideCode, category)).then((res) => {
            if (res.status === 'Success' && res.data && res.data.leadform) {
                dispatch(loadLeadFormData(res.data.leadform));
            } else {
                dispatch(showLeadFormLoader(false));
            }
        });
    };
}

// return callApi(`lead-form/city/${city}?slideCode=${slideCode}`, 'GET')
//   .then(res => {
//     if (res.status === 'Success') {
//       dispatch(loadLeadFormData(res.data.leadform));
//     } else {
//       dispatch(showLeadFormLoader(false));
//     }
//   });


